/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * Wren API
 * AI-powered relationship coaching platform API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnalyzeResponse,
  AuthVerifyRequest,
  AuthVerifyResponse,
  BodyAnalyzeScreenshotWebAnalyzePost,
  GuidedChatCreate,
  GuidedChatListResponse,
  GuidedChatRead,
  GuidedChatUpdate,
  HTTPValidationError,
  LogoutWebAuthLogoutPost200,
  SendMessageRequest,
  UserResponse
} from '../wrenAPI.schemas';

import { customInstance } from '../../../api/client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Upload a chat screenshot and get analysis results.
 * @summary Analyze Screenshot
 */
export type analyzeScreenshotWebAnalyzePostResponse200 = {
  data: AnalyzeResponse
  status: 200
}

export type analyzeScreenshotWebAnalyzePostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type analyzeScreenshotWebAnalyzePostResponseSuccess = (analyzeScreenshotWebAnalyzePostResponse200) & {
  headers: Headers;
};
export type analyzeScreenshotWebAnalyzePostResponseError = (analyzeScreenshotWebAnalyzePostResponse422) & {
  headers: Headers;
};

export type analyzeScreenshotWebAnalyzePostResponse = (analyzeScreenshotWebAnalyzePostResponseSuccess | analyzeScreenshotWebAnalyzePostResponseError)

export const getAnalyzeScreenshotWebAnalyzePostUrl = () => {


  

  return `/web/analyze`
}

export const analyzeScreenshotWebAnalyzePost = async (bodyAnalyzeScreenshotWebAnalyzePost: BodyAnalyzeScreenshotWebAnalyzePost, options?: RequestInit): Promise<analyzeScreenshotWebAnalyzePostResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyAnalyzeScreenshotWebAnalyzePost.file);

  return customInstance<analyzeScreenshotWebAnalyzePostResponse>(getAnalyzeScreenshotWebAnalyzePostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}
  



export const getAnalyzeScreenshotWebAnalyzePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeScreenshotWebAnalyzePost>>, TError,{data: BodyAnalyzeScreenshotWebAnalyzePost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeScreenshotWebAnalyzePost>>, TError,{data: BodyAnalyzeScreenshotWebAnalyzePost}, TContext> => {

const mutationKey = ['analyzeScreenshotWebAnalyzePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeScreenshotWebAnalyzePost>>, {data: BodyAnalyzeScreenshotWebAnalyzePost}> = (props) => {
          const {data} = props ?? {};

          return  analyzeScreenshotWebAnalyzePost(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeScreenshotWebAnalyzePostMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeScreenshotWebAnalyzePost>>>
    export type AnalyzeScreenshotWebAnalyzePostMutationBody = BodyAnalyzeScreenshotWebAnalyzePost
    export type AnalyzeScreenshotWebAnalyzePostMutationError = HTTPValidationError

    /**
 * @summary Analyze Screenshot
 */
export const useAnalyzeScreenshotWebAnalyzePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeScreenshotWebAnalyzePost>>, TError,{data: BodyAnalyzeScreenshotWebAnalyzePost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof analyzeScreenshotWebAnalyzePost>>,
        TError,
        {data: BodyAnalyzeScreenshotWebAnalyzePost},
        TContext
      > => {
      return useMutation(getAnalyzeScreenshotWebAnalyzePostMutationOptions(options), queryClient);
    }
    /**
 * Retrieve a persisted screenshot analysis by its short uid.
 * @summary Get Analysis
 */
export type getAnalysisWebAnalyzeUidGetResponse200 = {
  data: AnalyzeResponse
  status: 200
}

export type getAnalysisWebAnalyzeUidGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getAnalysisWebAnalyzeUidGetResponseSuccess = (getAnalysisWebAnalyzeUidGetResponse200) & {
  headers: Headers;
};
export type getAnalysisWebAnalyzeUidGetResponseError = (getAnalysisWebAnalyzeUidGetResponse422) & {
  headers: Headers;
};

export type getAnalysisWebAnalyzeUidGetResponse = (getAnalysisWebAnalyzeUidGetResponseSuccess | getAnalysisWebAnalyzeUidGetResponseError)

export const getGetAnalysisWebAnalyzeUidGetUrl = (uid: string,) => {


  

  return `/web/analyze/${uid}`
}

export const getAnalysisWebAnalyzeUidGet = async (uid: string, options?: RequestInit): Promise<getAnalysisWebAnalyzeUidGetResponse> => {
  
  return customInstance<getAnalysisWebAnalyzeUidGetResponse>(getGetAnalysisWebAnalyzeUidGetUrl(uid),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAnalysisWebAnalyzeUidGetQueryKey = (uid: string,) => {
    return [
    `/web/analyze/${uid}`
    ] as const;
    }

    
export const getGetAnalysisWebAnalyzeUidGetQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError = HTTPValidationError>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisWebAnalyzeUidGetQueryKey(uid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>> = ({ signal }) => getAnalysisWebAnalyzeUidGet(uid, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(uid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisWebAnalyzeUidGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>>
export type GetAnalysisWebAnalyzeUidGetQueryError = HTTPValidationError


export function useGetAnalysisWebAnalyzeUidGet<TData = Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError = HTTPValidationError>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisWebAnalyzeUidGet<TData = Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError = HTTPValidationError>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisWebAnalyzeUidGet<TData = Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError = HTTPValidationError>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Analysis
 */

export function useGetAnalysisWebAnalyzeUidGet<TData = Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError = HTTPValidationError>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisWebAnalyzeUidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisWebAnalyzeUidGetQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Log out the current user (client should clear token).
 * @summary Logout
 */
export type logoutWebAuthLogoutPostResponse200 = {
  data: LogoutWebAuthLogoutPost200
  status: 200
}

export type logoutWebAuthLogoutPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type logoutWebAuthLogoutPostResponseSuccess = (logoutWebAuthLogoutPostResponse200) & {
  headers: Headers;
};
export type logoutWebAuthLogoutPostResponseError = (logoutWebAuthLogoutPostResponse422) & {
  headers: Headers;
};

export type logoutWebAuthLogoutPostResponse = (logoutWebAuthLogoutPostResponseSuccess | logoutWebAuthLogoutPostResponseError)

export const getLogoutWebAuthLogoutPostUrl = () => {


  

  return `/web/auth/logout`
}

export const logoutWebAuthLogoutPost = async ( options?: RequestInit): Promise<logoutWebAuthLogoutPostResponse> => {
  
  return customInstance<logoutWebAuthLogoutPostResponse>(getLogoutWebAuthLogoutPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getLogoutWebAuthLogoutPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutWebAuthLogoutPost>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutWebAuthLogoutPost>>, TError,void, TContext> => {

const mutationKey = ['logoutWebAuthLogoutPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutWebAuthLogoutPost>>, void> = () => {
          

          return  logoutWebAuthLogoutPost(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutWebAuthLogoutPostMutationResult = NonNullable<Awaited<ReturnType<typeof logoutWebAuthLogoutPost>>>
    
    export type LogoutWebAuthLogoutPostMutationError = HTTPValidationError

    /**
 * @summary Logout
 */
export const useLogoutWebAuthLogoutPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutWebAuthLogoutPost>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logoutWebAuthLogoutPost>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutWebAuthLogoutPostMutationOptions(options), queryClient);
    }
    /**
 * Verify a magic link token and return a JWT.
 * @summary Verify Auth
 */
export type verifyAuthWebAuthVerifyPostResponse200 = {
  data: AuthVerifyResponse
  status: 200
}

export type verifyAuthWebAuthVerifyPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type verifyAuthWebAuthVerifyPostResponseSuccess = (verifyAuthWebAuthVerifyPostResponse200) & {
  headers: Headers;
};
export type verifyAuthWebAuthVerifyPostResponseError = (verifyAuthWebAuthVerifyPostResponse422) & {
  headers: Headers;
};

export type verifyAuthWebAuthVerifyPostResponse = (verifyAuthWebAuthVerifyPostResponseSuccess | verifyAuthWebAuthVerifyPostResponseError)

export const getVerifyAuthWebAuthVerifyPostUrl = () => {


  

  return `/web/auth/verify`
}

export const verifyAuthWebAuthVerifyPost = async (authVerifyRequest: AuthVerifyRequest, options?: RequestInit): Promise<verifyAuthWebAuthVerifyPostResponse> => {
  
  return customInstance<verifyAuthWebAuthVerifyPostResponse>(getVerifyAuthWebAuthVerifyPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      authVerifyRequest,)
  }
);}
  



export const getVerifyAuthWebAuthVerifyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyAuthWebAuthVerifyPost>>, TError,{data: AuthVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyAuthWebAuthVerifyPost>>, TError,{data: AuthVerifyRequest}, TContext> => {

const mutationKey = ['verifyAuthWebAuthVerifyPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyAuthWebAuthVerifyPost>>, {data: AuthVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  verifyAuthWebAuthVerifyPost(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyAuthWebAuthVerifyPostMutationResult = NonNullable<Awaited<ReturnType<typeof verifyAuthWebAuthVerifyPost>>>
    export type VerifyAuthWebAuthVerifyPostMutationBody = AuthVerifyRequest
    export type VerifyAuthWebAuthVerifyPostMutationError = HTTPValidationError

    /**
 * @summary Verify Auth
 */
export const useVerifyAuthWebAuthVerifyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyAuthWebAuthVerifyPost>>, TError,{data: AuthVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyAuthWebAuthVerifyPost>>,
        TError,
        {data: AuthVerifyRequest},
        TContext
      > => {
      return useMutation(getVerifyAuthWebAuthVerifyPostMutationOptions(options), queryClient);
    }
    /**
 * List all guided chats for the authenticated user.
 * @summary List Guided Chats
 */
export type listGuidedChatsWebGuidedChatsGetResponse200 = {
  data: GuidedChatListResponse
  status: 200
}

export type listGuidedChatsWebGuidedChatsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listGuidedChatsWebGuidedChatsGetResponseSuccess = (listGuidedChatsWebGuidedChatsGetResponse200) & {
  headers: Headers;
};
export type listGuidedChatsWebGuidedChatsGetResponseError = (listGuidedChatsWebGuidedChatsGetResponse422) & {
  headers: Headers;
};

export type listGuidedChatsWebGuidedChatsGetResponse = (listGuidedChatsWebGuidedChatsGetResponseSuccess | listGuidedChatsWebGuidedChatsGetResponseError)

export const getListGuidedChatsWebGuidedChatsGetUrl = () => {


  

  return `/web/guided-chats`
}

export const listGuidedChatsWebGuidedChatsGet = async ( options?: RequestInit): Promise<listGuidedChatsWebGuidedChatsGetResponse> => {
  
  return customInstance<listGuidedChatsWebGuidedChatsGetResponse>(getListGuidedChatsWebGuidedChatsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListGuidedChatsWebGuidedChatsGetQueryKey = () => {
    return [
    `/web/guided-chats`
    ] as const;
    }

    
export const getListGuidedChatsWebGuidedChatsGetQueryOptions = <TData = Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGuidedChatsWebGuidedChatsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>> = ({ signal }) => listGuidedChatsWebGuidedChatsGet({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGuidedChatsWebGuidedChatsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>>
export type ListGuidedChatsWebGuidedChatsGetQueryError = HTTPValidationError


export function useListGuidedChatsWebGuidedChatsGet<TData = Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>,
          TError,
          Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGuidedChatsWebGuidedChatsGet<TData = Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>,
          TError,
          Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGuidedChatsWebGuidedChatsGet<TData = Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Guided Chats
 */

export function useListGuidedChatsWebGuidedChatsGet<TData = Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGuidedChatsWebGuidedChatsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGuidedChatsWebGuidedChatsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Create a new guided chat.
 * @summary Create Guided Chat
 */
export type createGuidedChatWebGuidedChatsPostResponse201 = {
  data: GuidedChatRead
  status: 201
}

export type createGuidedChatWebGuidedChatsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createGuidedChatWebGuidedChatsPostResponseSuccess = (createGuidedChatWebGuidedChatsPostResponse201) & {
  headers: Headers;
};
export type createGuidedChatWebGuidedChatsPostResponseError = (createGuidedChatWebGuidedChatsPostResponse422) & {
  headers: Headers;
};

export type createGuidedChatWebGuidedChatsPostResponse = (createGuidedChatWebGuidedChatsPostResponseSuccess | createGuidedChatWebGuidedChatsPostResponseError)

export const getCreateGuidedChatWebGuidedChatsPostUrl = () => {


  

  return `/web/guided-chats`
}

export const createGuidedChatWebGuidedChatsPost = async (guidedChatCreate: GuidedChatCreate, options?: RequestInit): Promise<createGuidedChatWebGuidedChatsPostResponse> => {
  
  return customInstance<createGuidedChatWebGuidedChatsPostResponse>(getCreateGuidedChatWebGuidedChatsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      guidedChatCreate,)
  }
);}
  



export const getCreateGuidedChatWebGuidedChatsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuidedChatWebGuidedChatsPost>>, TError,{data: GuidedChatCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createGuidedChatWebGuidedChatsPost>>, TError,{data: GuidedChatCreate}, TContext> => {

const mutationKey = ['createGuidedChatWebGuidedChatsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGuidedChatWebGuidedChatsPost>>, {data: GuidedChatCreate}> = (props) => {
          const {data} = props ?? {};

          return  createGuidedChatWebGuidedChatsPost(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGuidedChatWebGuidedChatsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createGuidedChatWebGuidedChatsPost>>>
    export type CreateGuidedChatWebGuidedChatsPostMutationBody = GuidedChatCreate
    export type CreateGuidedChatWebGuidedChatsPostMutationError = HTTPValidationError

    /**
 * @summary Create Guided Chat
 */
export const useCreateGuidedChatWebGuidedChatsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuidedChatWebGuidedChatsPost>>, TError,{data: GuidedChatCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGuidedChatWebGuidedChatsPost>>,
        TError,
        {data: GuidedChatCreate},
        TContext
      > => {
      return useMutation(getCreateGuidedChatWebGuidedChatsPostMutationOptions(options), queryClient);
    }
    /**
 * Get a specific guided chat by ID.
 * @summary Get Guided Chat
 */
export type getGuidedChatWebGuidedChatsGuidedChatIdGetResponse200 = {
  data: GuidedChatRead
  status: 200
}

export type getGuidedChatWebGuidedChatsGuidedChatIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getGuidedChatWebGuidedChatsGuidedChatIdGetResponseSuccess = (getGuidedChatWebGuidedChatsGuidedChatIdGetResponse200) & {
  headers: Headers;
};
export type getGuidedChatWebGuidedChatsGuidedChatIdGetResponseError = (getGuidedChatWebGuidedChatsGuidedChatIdGetResponse422) & {
  headers: Headers;
};

export type getGuidedChatWebGuidedChatsGuidedChatIdGetResponse = (getGuidedChatWebGuidedChatsGuidedChatIdGetResponseSuccess | getGuidedChatWebGuidedChatsGuidedChatIdGetResponseError)

export const getGetGuidedChatWebGuidedChatsGuidedChatIdGetUrl = (guidedChatId: number,) => {


  

  return `/web/guided-chats/${guidedChatId}`
}

export const getGuidedChatWebGuidedChatsGuidedChatIdGet = async (guidedChatId: number, options?: RequestInit): Promise<getGuidedChatWebGuidedChatsGuidedChatIdGetResponse> => {
  
  return customInstance<getGuidedChatWebGuidedChatsGuidedChatIdGetResponse>(getGetGuidedChatWebGuidedChatsGuidedChatIdGetUrl(guidedChatId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetGuidedChatWebGuidedChatsGuidedChatIdGetQueryKey = (guidedChatId: number,) => {
    return [
    `/web/guided-chats/${guidedChatId}`
    ] as const;
    }

    
export const getGetGuidedChatWebGuidedChatsGuidedChatIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError = HTTPValidationError>(guidedChatId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuidedChatWebGuidedChatsGuidedChatIdGetQueryKey(guidedChatId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>> = ({ signal }) => getGuidedChatWebGuidedChatsGuidedChatIdGet(guidedChatId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(guidedChatId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuidedChatWebGuidedChatsGuidedChatIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>>
export type GetGuidedChatWebGuidedChatsGuidedChatIdGetQueryError = HTTPValidationError


export function useGetGuidedChatWebGuidedChatsGuidedChatIdGet<TData = Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError = HTTPValidationError>(
 guidedChatId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>,
          TError,
          Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuidedChatWebGuidedChatsGuidedChatIdGet<TData = Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError = HTTPValidationError>(
 guidedChatId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>,
          TError,
          Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuidedChatWebGuidedChatsGuidedChatIdGet<TData = Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError = HTTPValidationError>(
 guidedChatId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Guided Chat
 */

export function useGetGuidedChatWebGuidedChatsGuidedChatIdGet<TData = Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError = HTTPValidationError>(
 guidedChatId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuidedChatWebGuidedChatsGuidedChatIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuidedChatWebGuidedChatsGuidedChatIdGetQueryOptions(guidedChatId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Update a guided chat (e.g., submit feedback rating).
 * @summary Update Guided Chat
 */
export type updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponse200 = {
  data: GuidedChatRead
  status: 200
}

export type updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponseSuccess = (updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponse200) & {
  headers: Headers;
};
export type updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponseError = (updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponse422) & {
  headers: Headers;
};

export type updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponse = (updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponseSuccess | updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponseError)

export const getUpdateGuidedChatWebGuidedChatsGuidedChatIdPatchUrl = (guidedChatId: number,) => {


  

  return `/web/guided-chats/${guidedChatId}`
}

export const updateGuidedChatWebGuidedChatsGuidedChatIdPatch = async (guidedChatId: number,
    guidedChatUpdate: GuidedChatUpdate, options?: RequestInit): Promise<updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponse> => {
  
  return customInstance<updateGuidedChatWebGuidedChatsGuidedChatIdPatchResponse>(getUpdateGuidedChatWebGuidedChatsGuidedChatIdPatchUrl(guidedChatId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      guidedChatUpdate,)
  }
);}
  



export const getUpdateGuidedChatWebGuidedChatsGuidedChatIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuidedChatWebGuidedChatsGuidedChatIdPatch>>, TError,{guidedChatId: number;data: GuidedChatUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGuidedChatWebGuidedChatsGuidedChatIdPatch>>, TError,{guidedChatId: number;data: GuidedChatUpdate}, TContext> => {

const mutationKey = ['updateGuidedChatWebGuidedChatsGuidedChatIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGuidedChatWebGuidedChatsGuidedChatIdPatch>>, {guidedChatId: number;data: GuidedChatUpdate}> = (props) => {
          const {guidedChatId,data} = props ?? {};

          return  updateGuidedChatWebGuidedChatsGuidedChatIdPatch(guidedChatId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGuidedChatWebGuidedChatsGuidedChatIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateGuidedChatWebGuidedChatsGuidedChatIdPatch>>>
    export type UpdateGuidedChatWebGuidedChatsGuidedChatIdPatchMutationBody = GuidedChatUpdate
    export type UpdateGuidedChatWebGuidedChatsGuidedChatIdPatchMutationError = HTTPValidationError

    /**
 * @summary Update Guided Chat
 */
export const useUpdateGuidedChatWebGuidedChatsGuidedChatIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuidedChatWebGuidedChatsGuidedChatIdPatch>>, TError,{guidedChatId: number;data: GuidedChatUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGuidedChatWebGuidedChatsGuidedChatIdPatch>>,
        TError,
        {guidedChatId: number;data: GuidedChatUpdate},
        TContext
      > => {
      return useMutation(getUpdateGuidedChatWebGuidedChatsGuidedChatIdPatchMutationOptions(options), queryClient);
    }
    /**
 * Mark a guided chat as completed and start background invite message generation.
 * @summary Complete Guided Chat
 */
export type completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponse200 = {
  data: GuidedChatRead
  status: 200
}

export type completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponseSuccess = (completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponse200) & {
  headers: Headers;
};
export type completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponseError = (completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponse422) & {
  headers: Headers;
};

export type completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponse = (completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponseSuccess | completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponseError)

export const getCompleteGuidedChatWebGuidedChatsGuidedChatIdCompletePostUrl = (guidedChatId: number,) => {


  

  return `/web/guided-chats/${guidedChatId}/complete`
}

export const completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost = async (guidedChatId: number, options?: RequestInit): Promise<completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponse> => {
  
  return customInstance<completeGuidedChatWebGuidedChatsGuidedChatIdCompletePostResponse>(getCompleteGuidedChatWebGuidedChatsGuidedChatIdCompletePostUrl(guidedChatId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getCompleteGuidedChatWebGuidedChatsGuidedChatIdCompletePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost>>, TError,{guidedChatId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost>>, TError,{guidedChatId: number}, TContext> => {

const mutationKey = ['completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost>>, {guidedChatId: number}> = (props) => {
          const {guidedChatId} = props ?? {};

          return  completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost(guidedChatId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteGuidedChatWebGuidedChatsGuidedChatIdCompletePostMutationResult = NonNullable<Awaited<ReturnType<typeof completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost>>>
    
    export type CompleteGuidedChatWebGuidedChatsGuidedChatIdCompletePostMutationError = HTTPValidationError

    /**
 * @summary Complete Guided Chat
 */
export const useCompleteGuidedChatWebGuidedChatsGuidedChatIdCompletePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost>>, TError,{guidedChatId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeGuidedChatWebGuidedChatsGuidedChatIdCompletePost>>,
        TError,
        {guidedChatId: number},
        TContext
      > => {
      return useMutation(getCompleteGuidedChatWebGuidedChatsGuidedChatIdCompletePostMutationOptions(options), queryClient);
    }
    /**
 * Send a message and stream the assistant's response.
 * @summary Send Guided Chat Message
 */
export type sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponse200 = {
  data: unknown
  status: 200
}

export type sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponseSuccess = (sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponse200) & {
  headers: Headers;
};
export type sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponseError = (sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponse422) & {
  headers: Headers;
};

export type sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponse = (sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponseSuccess | sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponseError)

export const getSendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostUrl = (guidedChatId: number,) => {


  

  return `/web/guided-chats/${guidedChatId}/messages`
}

export const sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost = async (guidedChatId: number,
    sendMessageRequest: SendMessageRequest, options?: RequestInit): Promise<sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponse> => {
  
  return customInstance<sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostResponse>(getSendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostUrl(guidedChatId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendMessageRequest,)
  }
);}
  



export const getSendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost>>, TError,{guidedChatId: number;data: SendMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost>>, TError,{guidedChatId: number;data: SendMessageRequest}, TContext> => {

const mutationKey = ['sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost>>, {guidedChatId: number;data: SendMessageRequest}> = (props) => {
          const {guidedChatId,data} = props ?? {};

          return  sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost(guidedChatId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostMutationResult = NonNullable<Awaited<ReturnType<typeof sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost>>>
    export type SendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostMutationBody = SendMessageRequest
    export type SendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostMutationError = HTTPValidationError

    /**
 * @summary Send Guided Chat Message
 */
export const useSendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost>>, TError,{guidedChatId: number;data: SendMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPost>>,
        TError,
        {guidedChatId: number;data: SendMessageRequest},
        TContext
      > => {
      return useMutation(getSendGuidedChatMessageWebGuidedChatsGuidedChatIdMessagesPostMutationOptions(options), queryClient);
    }
    /**
 * Get current user context for homepage personalization.
 * @summary Get Me
 */
export type getMeWebMeGetResponse200 = {
  data: UserResponse
  status: 200
}

export type getMeWebMeGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getMeWebMeGetResponseSuccess = (getMeWebMeGetResponse200) & {
  headers: Headers;
};
export type getMeWebMeGetResponseError = (getMeWebMeGetResponse422) & {
  headers: Headers;
};

export type getMeWebMeGetResponse = (getMeWebMeGetResponseSuccess | getMeWebMeGetResponseError)

export const getGetMeWebMeGetUrl = () => {


  

  return `/web/me`
}

export const getMeWebMeGet = async ( options?: RequestInit): Promise<getMeWebMeGetResponse> => {
  
  return customInstance<getMeWebMeGetResponse>(getGetMeWebMeGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetMeWebMeGetQueryKey = () => {
    return [
    `/web/me`
    ] as const;
    }

    
export const getGetMeWebMeGetQueryOptions = <TData = Awaited<ReturnType<typeof getMeWebMeGet>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeWebMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeWebMeGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeWebMeGet>>> = ({ signal }) => getMeWebMeGet({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeWebMeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeWebMeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMeWebMeGet>>>
export type GetMeWebMeGetQueryError = HTTPValidationError


export function useGetMeWebMeGet<TData = Awaited<ReturnType<typeof getMeWebMeGet>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeWebMeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeWebMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMeWebMeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeWebMeGet<TData = Awaited<ReturnType<typeof getMeWebMeGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeWebMeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeWebMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMeWebMeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeWebMeGet<TData = Awaited<ReturnType<typeof getMeWebMeGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeWebMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Me
 */

export function useGetMeWebMeGet<TData = Awaited<ReturnType<typeof getMeWebMeGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeWebMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeWebMeGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




